import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

// Official logos of tools Beatview connects to (see /integrations). Files come from each
// vendor's own website and are shown only to describe compatibility, not endorsement.
// `h` is the rendered height in px, tuned so the marks look optically even.
const LOGOS = [
  { name: 'Bullhorn', src: '/logos/integrations/bullhorn.svg', aspect: 259 / 99, h: 38 },
  { name: 'Vincere', src: '/logos/integrations/vincere.png', aspect: 345 / 45, h: 22 },
  { name: 'JobAdder', src: '/logos/integrations/jobadder.svg', aspect: 142 / 24, h: 22 },
  { name: 'Greenhouse', src: '/logos/integrations/greenhouse.svg', aspect: 140 / 32, h: 26 },
  { name: 'Workable', src: '/logos/integrations/workable.svg', aspect: 194 / 32, h: 24 },
  { name: 'Zapier', src: '/logos/integrations/zapier.svg', aspect: 244 / 66, h: 24 },
  { name: 'LinkedIn', src: '/logos/integrations/linkedin.svg', aspect: 568 / 144, h: 24 },
  { name: 'Indeed', src: '/logos/integrations/indeed.svg', aspect: 1486 / 400, h: 28 },
  { name: 'Zoom', src: '/logos/integrations/zoom.svg', aspect: 90.6 / 20.6, h: 20 },
  { name: 'Calendly', src: '/logos/integrations/calendly.svg', aspect: 116 / 28, h: 24 },
];

export function IntegrationLogos() {
  return (
    <section aria-labelledby="integration-logos-title" className="border-y border-bv-blue-line bg-white py-9 lg:py-11">
      <div className="mx-auto max-w-[1240px] px-5 lg:px-8">
        <div className="flex flex-col items-center gap-2 text-center">
          <h2 id="integration-logos-title" className="text-[13px] font-semibold uppercase tracking-[0.16em] text-bv-ink2">
            Works with the ATS and tools your agency already uses
          </h2>
          <Link to="/integrations" className="inline-flex items-center gap-1 text-sm font-semibold text-bv-blue hover:underline">
            See all integrations <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        </div>
        <div className="bv-mask-fade-x relative mt-7 overflow-hidden">
          <ul className="flex w-max animate-marquee items-center [animation-duration:45s] hover:[animation-play-state:paused]">
            {[...LOGOS, ...LOGOS].map((logo, i) => (
              <li key={`${logo.name}-${i}`} aria-hidden={i >= LOGOS.length} className="flex h-10 items-center px-7 sm:px-10">
                <img
                  src={logo.src}
                  alt={i >= LOGOS.length ? '' : logo.name}
                  width={Math.round(logo.h * logo.aspect)}
                  height={logo.h}
                  loading="lazy"
                  decoding="async"
                  className="w-auto max-w-none opacity-60 grayscale transition duration-300 hover:opacity-100 hover:grayscale-0"
                  style={{ height: logo.h }}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
